import "./styles/main.scss";
import Router from "./Routes/Router";

function App() {
    return (
        <div className="h-full mt-[4.4rem]">
            <Router />
        </div>
    );
}

export default App;
